import OfferingCardBuilder from 'components/OfferingCardBuilder';
import React from 'react';
import { CatalogEntry, OfferingVisibility } from 'types';
import MODALITIES_WITH_LANDING_PAGE from '../utils';
import BaseOfferingCardWithLiveClass from './BaseOfferingCardWithLiveClass';

type OfferingCardProps = {
  className?: string;
  /**
   * The catalog entry to display.
   */
  entry?: CatalogEntry;
  /**
   * Whether to show the live virtual class information in the card for offerings with modality "course".
   */
  coursesShowLiveClassInfo?: boolean;
  availableLabel?: string;
  /**
   * Always use the "View" primary action and open the offering landing page,
   * even when the user has progress.
   */
  isSearch?: boolean;
};

const BaseOfferingCard: React.FC<OfferingCardProps> = ({
  className,
  entry,
  coursesShowLiveClassInfo = false,
  availableLabel,
  isSearch = false,
}) => {
  const isLocked = entry?.visibility === OfferingVisibility.Upgrade;
  const hideAllActionButtons =
    isLocked &&
    entry?.modality != null &&
    !MODALITIES_WITH_LANDING_PAGE.includes(entry.modality);

  if (coursesShowLiveClassInfo) {
    // this enables the live virtual class information to be displayed in the card
    return (
      <BaseOfferingCardWithLiveClass
        className={className}
        entry={entry}
        isLocked={isLocked}
        isSearch={isSearch}
        hideAllActionButtons={hideAllActionButtons}
      />
    );
  }

  return (
    <OfferingCardBuilder
      className={className}
      entry={entry}
      isLocked={isLocked}
      isSearch={isSearch}
    >
      <OfferingCardBuilder.Header />
      <OfferingCardBuilder.Body availableLabel={availableLabel} />
      <OfferingCardBuilder.Footer hideAllActionButtons={hideAllActionButtons} />
    </OfferingCardBuilder>
  );
};

export default BaseOfferingCard;
